import { axiosInstance } from './api';

export interface InstantFrameResponse {
  id?: number;
  image: string;
  // other fields if needed
}

export const getInstantFrame = (cameraId: string) => {
  return axiosInstance.get<InstantFrameResponse>(`/core/api/frames/instant/?camera_id=${cameraId}`);
};

export const getLatestFrame = (cameraId: string) => {
  return axiosInstance.get<InstantFrameResponse>(`/core/api/frames/latest/?camera_id=${cameraId}`);
};

/** Кроп полигона, нарезанный бэкендом тем же кодом, что пайплайн, с осветлением (JPEG). */
export const getCropPreview = (params: {
  frame_id: number; points: string; width: number; height: number; brighten: number;
}) => {
  return axiosInstance.get<Blob>('/core/api/frames/crop_preview/', { params, responseType: 'blob' });
};
